module.exports = __webpack_public_path__ + "sites@3x--fe9a29ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/sites/sites@3x.jpg
// module id = 134
// module chunks = 0